import { useState } from 'react';
import { mockArticles } from '@/mocks/articles';

const columns = [
  { id: 'rascunho', label: 'Rascunhos', borderColor: 'border-t-[#999999]', dotColor: 'bg-[#999999]', textColor: 'text-[#666666]' },
  { id: 'revisão', label: 'Em Revisão', borderColor: 'border-t-[#B8860B]', dotColor: 'bg-[#B8860B]', textColor: 'text-[#B8860B]' },
  { id: 'aprovado', label: 'Aprovado', borderColor: 'border-t-[#1a7a1a]', dotColor: 'bg-[#1a7a1a]', textColor: 'text-[#1a7a1a]' },
  { id: 'publicado', label: 'Publicado', borderColor: 'border-t-[#111111]', dotColor: 'bg-[#111111]', textColor: 'text-[#111111]' },
];

const sectionColors: Record<string, string> = {
  Política: 'text-[#C41230]',
  Esportes: 'text-[#1a7a1a]',
  Cultura: 'text-[#5B2D8E]',
  Economia: 'text-[#B8860B]',
  Ciência: 'text-[#0066AA]',
};

export default function PipelineBoard() {
  const [articles, setArticles] = useState(mockArticles);
  const [dragging, setDragging] = useState<string | null>(null);

  const handleDragStart = (id: string) => setDragging(id);
  const handleDrop = (status: string) => {
    if (!dragging) return;
    setArticles((prev) => prev.map((a) => (a.id === dragging ? { ...a, status } : a)));
    setDragging(null);
  };

  return (
    <div className="bg-white border border-[#E0E0E0]">
      <div className="px-5 py-3 border-b-2 border-[#111111] flex items-center justify-between">
        <h2 className="text-sm font-bold text-[#111111] font-serif uppercase tracking-wide">Pipeline Editorial</h2>
        <div className="flex items-center gap-3">
          <span className="text-[11px] text-[#999999] font-sans">{articles.length} artigos</span>
          <button className="text-[11px] text-[#C41230] font-semibold font-sans cursor-pointer hover:underline">Ver todos</button>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-0 divide-x divide-[#E0E0E0]">
        {columns.map((col) => {
          const colArticles = articles.filter((a) => a.status === col.id);
          return (
            <div
              key={col.id}
              className={`p-3 min-h-52 border-t-2 ${col.borderColor}`}
              onDragOver={(e) => e.preventDefault()}
              onDrop={() => handleDrop(col.id)}
            >
              <div className="flex items-center gap-1.5 mb-3">
                <div className={`w-1.5 h-1.5 rounded-full ${col.dotColor}`}></div>
                <span className={`text-[10px] font-bold uppercase tracking-wider font-sans ${col.textColor}`}>{col.label}</span>
                <span className={`ml-auto text-[10px] font-bold font-sans ${col.textColor}`}>{colArticles.length}</span>
              </div>
              <div className="space-y-2">
                {colArticles.map((article) => (
                  <div
                    key={article.id}
                    draggable
                    onDragStart={() => handleDragStart(article.id)}
                    className="bg-white border border-[#E0E0E0] p-2.5 cursor-grab active:cursor-grabbing hover:border-[#111111] transition-colors"
                  >
                    <p className="text-xs font-bold text-[#111111] font-serif leading-tight mb-1.5 line-clamp-2">{article.title}</p>
                    <div className="flex items-center justify-between">
                      <span className={`text-[10px] font-bold font-sans ${sectionColors[article.section] || 'text-[#666666]'}`}>
                        {article.section}
                      </span>
                      <span className="text-[10px] text-[#999999] font-sans">{article.author.split(' ')[0]}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
